import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listLocationsTree } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.LIST.TREE,
  api: listLocationsTree,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/locations/ListTreeAction.js